export default "__VITE_ASSET__DI4LQz2i__"